export default "data:image/png;base64,"